import { render } from "./AdminDashboard.vue?vue&type=template&id=26d53c57"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"

import "./AdminDashboard.vue?vue&type=style&index=0&id=26d53c57&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__